/* eslint-disable no-param-reassign */
/**
 * request 网络请求工具
 * 更详细的 api 文档 https://github.com/umijs/umi-request
 */
import { request, formatMessage } from 'umi';
import { notification } from 'antd';
// import { get } from 'lodash';
// import { async } from 'q';
import token from './token';
import { get, values } from 'lodash';

const codeMessage = {
  200: 'Successfully updated.',
  201: 'Successfully updated.',
  202: 'Your request is queued.',
  204: 'Successfully removed.',
  400: 'Oops!',
  401: 'Your session is expired. Please login again.',
  403: 'You are not authorized for the request.',
  404: 'Entity not found.',
  406: 'Invalid format.',
  409: 'Oops!',
  410: 'Request entity does not exist.',
  422: 'Validation error.',
  500: 'Oops!',
  502: 'NAT error.',
  503: 'Service is currently unavailable. Please try again later.',
  504: 'Your request has timeouted. Please try again later',
};

const descriptions = {
  400: 'Something was not right. Please try again.',
  409: 'Something went wrong. Please refresh your page and try again.',
  500: 'Something went wrong. Please refresh your page and try again.',
};

/**
 * 异常处理程序
 */
export async function errorHandler(error, intl) {
  if (!error || !error.response) {
    // network error
    notification.error({
      message: codeMessage[500],
      description: descriptions[500],
    });
    return;
  }
  const { response } = error;
  const errortext = codeMessage[response.status] || response.statusText;
  const { status } = response;
  let body;
  try {
    body = await response.json();
  } catch (err) {
    body = undefined;
  }
  if (status === 401 || status === 403) {
    if (window.location.pathname !== '/login') {
      window.location.href = '/login?session_expired=1';
    }
    return body;
  }
  let description = descriptions[status];
  if (body) {
    const errorMessages = getFormattedErrorMessages(body);
    if (errorMessages && errorMessages.length > 0) {
      description = intl
        ? intl.formatMessage({
            id: errorMessages[0].id,
            defaultMessage: errorMessages[0].message,
          })
        : errorMessages[0].message;
    } else if (body.message && typeof body.message === 'string') {
      // TODO: 不支持刷新,暂时未找到 umi 的方法
      description = formatMessage({
        id: body.message,
        defaultMessage: body.message,
      });
      if (body.data?.errors && values(body.data.errors).length) {
        description = (
          <div>
            <div>{description}</div>
            {values(body.data.errors).map(error => (
              <div key={error}>{error}</div>
            ))}
          </div>
        );
      }
    }
    if (!description && typeof body === 'string') {
      description = body;
    }
  }
  notification.error({
    message: errortext,
    description,
  });
}

// return [{ id: string, message: string }]
export function getFormattedErrorMessages(response) {
  if (!response || !response.error) return;
  const messages = get(response, 'data[0].messages');
  if (!messages || !messages.length || !Array.isArray(messages) || !messages[0].message) return;
  return messages;
}

export function buildAuthorization() {
  const tokenVal = token.get();
  return tokenVal ? `Bearer ${tokenVal}` : '';
}

// 请求体里这些 key 的值原样保留、不 trim:密码类前后空格可能是有意的,
// trim 掉会静默破坏登录/改密/SMTP 认证。'pass' 是 SMTP 设置里的邮箱密码字段(见 services/user.ts)。
export const BODY_TRIM_SKIP_KEYS = ['password', 'new_password', 'passwordConfirmation', 'pass'];

// skipKeys: 这些 key 的值原样保留、不 trim(如密码,前后空格可能是有意的)
export function trimParams(params, { skipKeys = [] } = {}) {
  const trim = value => {
    if (typeof value === 'string') return value.trim();
    if (Array.isArray(value)) return value.map(trim);
    // 只递归普通对象,跳过 Date / File / Blob 等特殊对象
    if (value && typeof value === 'object' && value.constructor === Object) {
      Object.keys(value).forEach(k => {
        value[k] = skipKeys.includes(k) ? value[k] : trim(value[k]);
      });
      return value;
    }
    return value; // null / undefined / number / boolean / 其它原样
  };
  return trim(params);
}

export default request;
